/* eslint-disable max-len */
import * as React from "react";
import "./gear.css";

export const GearIcon = () => (
  <svg
    className="gearIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-45 -50 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <g transform="rotate(-132.325 36.046 13.954)">
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="0;360"
        keyTimes="0;1"
        dur="4.4s"
        repeatCount="indefinite"
      />
      <path
        d="M37.44-6.5h10v13h-10a38 38 0 0 1-1.766 6.59l8.66 5-6.5 11.26-8.66-5a38 38 0 0 1-4.825 4.824l5 8.66-11.258 6.5-5-8.66A38 38 0 0 1 6.5 37.44v10h-13v-10a38 38 0 0 1-6.59-1.766l-5 8.66-11.26-6.5 5-8.66a38 38 0 0 1-4.824-4.825l-8.66 5-6.5-11.258 8.66-5A38 38 0 0 1-37.44 6.5h-10v-13h10a38 38 0 0 1 1.766-6.59l-8.66-5 6.5-11.26 8.66 5a38 38 0 0 1 4.825-4.824l-5-8.66 11.258-6.5 5 8.66A38 38 0 0 1-6.5-37.44v-10h13v10a38 38 0 0 1 6.59 1.766l5-8.66 11.26 6.5-5 8.66a38 38 0 0 1 4.824 4.825l8.66-5 6.5 11.258-8.66 5A38 38 0 0 1 37.44-6.5M0-20a20 20 0 1 0 0 40 20 20 0 1 0 0-40"
        fill="#979aaa"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Shared/gear/gear.tsx